import { render, staticRenderFns } from "./MasterMobile.vue?vue&type=template&id=cafc4c88"
import script from "./MasterMobile.vue?vue&type=script&lang=js"
export * from "./MasterMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports